import { LeafAnimation } from '@typedream/core';
import { isCollapsed, select } from '@udecode/plate-core';
import { DreamEditor } from '../../types';

export const addLeafAnimationAtSelection = (
  editor: DreamEditor,
  animation: LeafAnimation,
) => {
  if (!editor.selection || isCollapsed(editor.selection)) return;
  editor.addMark('animation', animation);
};

export const removeLeafAnimationAtSelection = (
  editor: DreamEditor,
) => {
  if (!editor.selection) return;

  // Select if selection is collapsed
  if (isCollapsed(editor.selection)) {
    select(editor, editor.selection?.anchor?.path);
  }

  editor.removeMark('animation');
};
